/**
 * NBC medición propia — POST /api/publico/e (lote, 204, fire-and-forget).
 * Sin PII. Respeta DNT y nbc_no_track. Nunca lanza al caller.
 */
(function () {
  'use strict';

  var LS_VID = 'nbc_vid';
  var LS_SID = 'nbc_sid';
  var LS_SID_TS = 'nbc_sid_ts';
  var LS_SID_REF = 'nbc_sid_ref';
  var LS_TOQUE = 'nbc_toque';
  var LS_NO_TRACK = 'nbc_no_track';
  var SS_VP = 'nbc_med_vp_seen';
  var SS_VC = 'nbc_med_vc_seen';
  var INACT_MS = 30 * 60 * 1000;
  var TOQUE_MS = 7 * 24 * 60 * 60 * 1000;
  var MAX_BATCH = 20;
  var FLUSH_MS = 10000;

  var queue = [];
  var lastFlush = 0;
  var flushTimer = null;
  var started = false;

  function safe(fn) {
    try { return fn(); } catch (_) { return undefined; }
  }

  function lsGet(k) {
    try { return localStorage.getItem(k); } catch (_) { return null; }
  }

  function lsSet(k, v) {
    try { localStorage.setItem(k, v); } catch (_) { /* noop */ }
  }

  function lsRemove(k) {
    try { localStorage.removeItem(k); } catch (_) { /* noop */ }
  }

  function genId(prefix) {
    var raw = (prefix || 'id') + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    raw = raw.toLowerCase().replace(/[^a-z0-9-]/g, '');
    if (raw.length < 8) raw = (raw + '00000000').slice(0, 8);
    return raw.slice(0, 64);
  }

  function normalizarRef(ref) {
    if (ref == null || ref === '') return null;
    var s = String(ref).trim().toLowerCase().replace(/[^a-z0-9-]/g, '');
    if (s.length > 40) s = s.slice(0, 40);
    if (s.length < 2) return null;
    if (!/^[a-z0-9-]{2,40}$/.test(s)) return null;
    return s;
  }

  function normalizarRuta(path) {
    var p = path || (typeof location !== 'undefined' ? location.pathname : '/');
    p = String(p).trim();
    if (!p) p = '/';
    if (p.charAt(0) !== '/') p = '/' + p;
    var q = p.indexOf('?');
    if (q >= 0) p = p.slice(0, q);
    var h = p.indexOf('#');
    if (h >= 0) p = p.slice(0, h);
    p = p.replace(/\/+/g, '/');
    if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
    if (p.length > 120) p = p.slice(0, 120);
    return p || '/';
  }

  function inferTemplate() {
    var p = normalizarRuta();
    if (p === '/') return 'index';
    if (p.indexOf('/products/') === 0) return 'product';
    if (p.indexOf('/collections/') === 0) return 'collection';
    if (p.indexOf('/pages/') === 0) {
      var slug = p.slice('/pages/'.length).split('/')[0];
      return slug ? 'page.' + slug : 'page';
    }
    if (p.indexOf('/blogs/') === 0) return 'blog';
    if (p.indexOf('/search') === 0) return 'search';
    return 'other';
  }

  function dntActivo() {
    return safe(function () {
      var d = navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack;
      return d === '1' || d === 'yes';
    }) === true;
  }

  function noTrackLocal() {
    return lsGet(LS_NO_TRACK) === '1';
  }

  function shouldTrack() {
    if (dntActivo() || noTrackLocal()) return false;
    if (typeof NBC_API !== 'string' || !NBC_API) return false;
    return true;
  }

  function parseUrlParams() {
    return safe(function () {
      return new URLSearchParams(location.search);
    }) || null;
  }

  function procesarFlagsUrl() {
    safe(function () {
      var p = parseUrlParams();
      if (!p) return;
      var nt = p.get('nbc_no_track');
      if (nt === '1') lsSet(LS_NO_TRACK, '1');
      if (nt === '0') lsRemove(LS_NO_TRACK);
    });
  }

  function guardarToqueDesdeUrl() {
    safe(function () {
      var p = parseUrlParams();
      if (!p) return;
      var ref = normalizarRef(p.get('ref'));
      var utmSource = p.get('utm_source');
      var utmMedium = p.get('utm_medium');
      var utmCampaign = p.get('utm_campaign');
      if (!ref && !utmSource && !utmMedium && !utmCampaign) return;
      var payload = {
        ref: ref,
        utm: {
          source: utmSource || null,
          medium: utmMedium || null,
          campaign: utmCampaign || null
        },
        landing: normalizarRuta(),
        ts: new Date().toISOString()
      };
      lsSet(LS_TOQUE, JSON.stringify(payload));
    });
  }

  function leerToque() {
    return safe(function () {
      var raw = lsGet(LS_TOQUE);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.ts) return null;
      var ms = Date.parse(o.ts);
      if (!Number.isFinite(ms) || Date.now() - ms > TOQUE_MS) {
        lsRemove(LS_TOQUE);
        return null;
      }
      return o;
    }) || null;
  }

  function getVisitorId() {
    return safe(function () {
      var vid = lsGet(LS_VID);
      if (vid && /^[a-z0-9-]{8,64}$/.test(vid)) return vid;
      vid = genId('vid');
      lsSet(LS_VID, vid);
      return vid;
    }) || genId('vid');
  }

  function touchSessionId(refFromUrl) {
    return safe(function () {
      var now = Date.now();
      var sid = lsGet(LS_SID);
      var sidTs = parseInt(lsGet(LS_SID_TS), 10) || 0;
      var sidRef = lsGet(LS_SID_REF) || '';
      var inactive = !sidTs || now - sidTs > INACT_MS;
      var refChanged = !!(refFromUrl && sidRef && refFromUrl !== sidRef);
      if (!sid || !/^[a-z0-9-]{8,64}$/.test(sid) || inactive || refChanged) {
        sid = genId('sid');
        sidRef = refFromUrl || sidRef || '';
      }
      if (refFromUrl) sidRef = refFromUrl;
      lsSet(LS_SID, sid);
      lsSet(LS_SID_TS, String(now));
      lsSet(LS_SID_REF, sidRef);
      return sid;
    }) || genId('sid');
  }

  function bumpActividad() {
    safe(function () { lsSet(LS_SID_TS, String(Date.now())); });
  }

  function getDispositivo() {
    var w = typeof window !== 'undefined' ? window.innerWidth : 1024;
    if (w < 750) return 'mobile';
    if (w < 990) return 'tablet';
    return 'desktop';
  }

  function referrerHost() {
    return safe(function () {
      var ref = typeof document !== 'undefined' ? document.referrer : '';
      if (!ref) return null;
      try {
        var host = new URL(ref).hostname.toLowerCase();
        if (!host || host.length > 80) return host ? host.slice(0, 80) : null;
        return host;
      } catch (_) {
        return null;
      }
    }) || null;
  }

  function detectarPlataforma() {
    return safe(function () {
      if (typeof nbcEsAppNativa === 'function' && nbcEsAppNativa()) {
        if (window.Capacitor && typeof window.Capacitor.getPlatform === 'function') {
          var p = window.Capacitor.getPlatform();
          if (p === 'ios' || p === 'android') return p;
        }
        return 'web';
      }
      return 'web';
    }) || 'web';
  }

  function buildSesionPayload() {
    var toque = leerToque();
    var ref = toque && toque.ref ? String(toque.ref) : null;
    var utm = toque && toque.utm ? toque.utm : {};
    var esApp = typeof nbcEsAppNativa === 'function' && nbcEsAppNativa() === true;
    var payload = {
      ref: ref,
      utm_source: utm.source || null,
      utm_medium: utm.medium || null,
      utm_campaign: utm.campaign || null,
      landing: (toque && toque.landing) ? normalizarRuta(toque.landing) : normalizarRuta(),
      dispositivo: getDispositivo(),
      es_app: esApp,
      referrer_host: referrerHost(),
      plataforma: detectarPlataforma()
    };
    if (ref === 'test-staging') payload.es_test = true;
    return payload;
  }

  function eventoBase(extra) {
    var ev = {
      t: extra.t,
      p: normalizarRuta(),
      tpl: inferTemplate()
    };
    if (extra.a) ev.a = extra.a;
    if (extra.pr) ev.pr = extra.pr;
    return ev;
  }

  function enqueue(ev) {
    if (!shouldTrack()) return;
    bumpActividad();
    queue.push(ev);
    if (queue.length >= MAX_BATCH) flush(true);
    else scheduleFlush();
  }

  function scheduleFlush() {
    if (flushTimer) return;
    flushTimer = setTimeout(function () {
      flushTimer = null;
      flush(true);
    }, FLUSH_MS);
  }

  function buildLote(eventos) {
    var p = parseUrlParams();
    var refUrl = p && p.get('ref');
    touchSessionId(refUrl || lsGet(LS_SID_REF) || null);
    return {
      sid: lsGet(LS_SID) || genId('sid'),
      vid: getVisitorId(),
      sesion: buildSesionPayload(),
      eventos: eventos
    };
  }

  function endpointUrl() {
    var base = typeof NBC_API === 'string' ? NBC_API : '';
    return base.replace(/\/+$/, '') + '/api/publico/e';
  }

  function sendBatch(eventos) {
    if (!eventos || !eventos.length) return;
    safe(function () {
      var body = JSON.stringify(buildLote(eventos));
      var url = endpointUrl();
      var sent = false;
      // text/plain evita preflight CORS cross-origin (application/json + sendBeacon falla silenciosamente).
      var beaconType = 'text/plain;charset=UTF-8';
      if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
        try {
          sent = navigator.sendBeacon(url, new Blob([body], { type: beaconType }));
        } catch (_) { sent = false; }
      }
      if (!sent && typeof fetch === 'function') {
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': beaconType },
          body: body,
          keepalive: true,
          credentials: 'omit'
        }).catch(function () {});
      }
    });
  }

  function flush(force) {
    if (!shouldTrack()) {
      queue = [];
      return;
    }
    var now = Date.now();
    if (!force && now - lastFlush < FLUSH_MS) return;
    if (!queue.length) return;
    while (queue.length) {
      var batch = queue.splice(0, MAX_BATCH);
      sendBatch(batch);
    }
    lastFlush = now;
  }

  function viewProductOnce(handle) {
    if (!handle || !shouldTrack()) return;
    safe(function () {
      var key = String(handle);
      var raw = sessionStorage.getItem(SS_VP);
      var seen = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(seen)) seen = [];
      if (seen.indexOf(key) >= 0) return;
      seen.push(key);
      sessionStorage.setItem(SS_VP, JSON.stringify(seen));
      enqueue(eventoBase({ t: 'view_product', pr: key }));
    });
  }

  function trackPageView() {
    enqueue(eventoBase({ t: 'page_view' }));
  }

  function trackViewCart() {
    if (normalizarRuta().indexOf('/pages/carrito-v2') !== 0) return;
    safe(function () {
      if (sessionStorage.getItem(SS_VC) === '1') return;
      sessionStorage.setItem(SS_VC, '1');
      enqueue(eventoBase({ t: 'view_cart' }));
    });
  }

  function wrapQuickAdd() {
    safe(function () {
      if (typeof window.openQuickAddModal !== 'function') return;
      if (window.openQuickAddModal.__nbcMedWrapped) return;
      var orig = window.openQuickAddModal;
      function wrapped(handle) {
        var r = orig.apply(this, arguments);
        if (handle) viewProductOnce(String(handle));
        return r;
      }
      wrapped.__nbcMedWrapped = true;
      window.openQuickAddModal = wrapped;
    });
  }

  function bindClicks() {
    document.addEventListener('click', function (e) {
      safe(function () {
        if (!shouldTrack()) return;
        var el = e.target && e.target.closest ? e.target.closest('[data-accion]') : null;
        if (!el) return;
        var a = el.getAttribute('data-accion');
        if (!a || !/^[a-z0-9-]{1,40}$/.test(a)) return;
        enqueue(eventoBase({ t: 'click', a: a }));
      });
    }, true);
  }

  function initPageEvents() {
    trackPageView();
    trackViewCart();
    if (inferTemplate() === 'product') {
      var root = document.querySelector('[data-product-handle]');
      if (root) viewProductOnce(root.getAttribute('data-product-handle'));
    }
    wrapQuickAdd();
  }

  function nbcMedLeerAtribucion() {
    return safe(function () {
      if (!shouldTrack()) return null;
      var toque = leerToque();
      var refParam = null;
      var p = parseUrlParams();
      if (p) refParam = normalizarRef(p.get('ref'));
      var refCodigo = toque && toque.ref ? normalizarRef(toque.ref) : null;
      touchSessionId(refCodigo || refParam || lsGet(LS_SID_REF) || null);
      var utm = toque && toque.utm ? toque.utm : {};
      var utmOut = {
        source: utm.source || null,
        medium: utm.medium || null,
        campaign: utm.campaign || null
      };
      return {
        visitor_id: getVisitorId(),
        session_id: lsGet(LS_SID) || touchSessionId(refCodigo || refParam || null),
        ref_codigo: refCodigo,
        utm: utmOut,
        landing_path: toque && toque.landing ? normalizarRuta(toque.landing) : normalizarRuta(),
        toque_ts: toque && toque.ts ? toque.ts : null
      };
    }) || null;
  }

  function nbcMedTrackAddToCart(productHandle, accion) {
    safe(function () {
      if (!shouldTrack() || !productHandle) return;
      var ev = eventoBase({ t: 'add_to_cart', pr: String(productHandle) });
      if (accion && /^[a-z0-9-]{1,40}$/.test(accion)) ev.a = accion;
      enqueue(ev);
    });
  }

  function nbcMedFlush() {
    flush(true);
  }

  function boot() {
    if (started) return;
    started = true;
    procesarFlagsUrl();
    guardarToqueDesdeUrl();
    if (!shouldTrack()) return;
    var p = parseUrlParams();
    touchSessionId(p && normalizarRef(p.get('ref')));
    bindClicks();
    initPageEvents();
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush(true);
    });
    window.addEventListener('pagehide', function () { flush(true); });
  }

  window.nbcMedLeerAtribucion = nbcMedLeerAtribucion;
  window.nbcMedTrackAddToCart = nbcMedTrackAddToCart;
  window.nbcMedFlush = nbcMedFlush;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


